import { Component, ElementRef, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { RSFRoleNotificationSetting, RSFSettings, RSFSettingType } from '../rsf-settings';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Subscription } from 'rxjs';
import { Role } from 'src/app/components/catalogs/roles/services/role';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { FormType } from 'src/app/common/enumerations/enumerations';
import { CdkDragDrop, CdkDragStart, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'rsf-settings-role-notifications',
  templateUrl: './rsf-settings-role-notifications.component.html',
  styleUrls: ['./rsf-settings-role-notifications.component.scss']
})
export class RsfSettingsRoleNotificationsComponent extends BaseComponent implements OnChanges {
  @Input() rsfSettings?: RSFSettings[];
  @Output() changed = new EventEmitter<RSFSettings[]>();

  @ViewChild("roleInput") roleInput!: ElementRef<HTMLInputElement>;

  roles?: Role[];
  rolesFiltered: Role[] = [];
  rolesSubs!: Subscription;

  roleNotificationSettings?: RSFRoleNotificationSetting[];

  conditions?: string[];
  tmpRoleNotification?: RSFRoleNotificationSetting | null;

  constructor(
    protected override injector: Injector,
    private _workflow: WorkFlowService
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.rsfSettings = this.rsfSettings?.filter(s => s.type == RSFSettingType.Notifications);
    this.loadRoles();
  }

  loadRoles() {
    this.rolesSubs = this.store.select(state => state.Roles.data).subscribe(data => {
      if (data?.length) {
        this.roles = data;
        this.setValues();
        this.filterRoles();
      }
    });
  }

  filterRoles(e?: any) {
    let filter: string;
    if (e) filter = e.target.value;
    this.rolesFiltered = this.roles
      ?.filter(r => !this.roleNotificationSettings
        ?.map(n => n.roleID).includes(r.id) &&
        (filter && r.name?.toLowerCase().includes(filter.toLowerCase()) ||
          filter && r.code?.toLowerCase().includes(filter.toLowerCase()) ||
          !filter))
      .sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.name, b.name)) ?? [];
  }

  setValues() {
    this.roleNotificationSettings = [];
    this.rsfSettings?.forEach(s => {
      const value = this.utils.JSONparse(s.defaultValue) as RSFRoleNotificationSetting;
      const rn = {
        id: s.id,
        name: value?.name ?? s.name,
        description: value?.description ?? s.description,
        type: s.type,
        roleID: value?.roleID,
        role: this.roles?.find(r => r.id == value?.roleID),
        checked: value?.checked,
        conditions: value?.conditions,
        disabled: true,
        order: value?.order
      } as RSFRoleNotificationSetting;
      this.roleNotificationSettings?.push(rn);
    });
    this.roleNotificationSettings.sort((a, b) => this.utils.sort(a.order, b.order));
  }

  override displayObject = (role?: { name: string; } | null) => role ? role.name : '';

  onRoleSelected(r: RSFRoleNotificationSetting, e: MatAutocompleteSelectedEvent) {
    r.role = e.option.value as Role;     // store the selected object
    this.roleQuery = ''; // replace typed text
    this.roleInput.nativeElement.value = "";
    r.roleID = r.role?.id ?? null;
  }

  clearRole(r: RSFRoleNotificationSetting) {
    r.role = null;
    r.roleID = null;
  }

  save() {
    const settings: RSFSettings[] = [];
    this.roleNotificationSettings?.forEach(n => {
      if (n.role) n.role = { id: n.role.id, name: n.role.name, code: n.role.code } as Role;
      const s = {
        id: n.id,
        name: n.name,
        description: n.description,
        conditions: n.conditions,
        type: n.type,
        defaultValue: this.utils.JSONstringify(n)
      } as RSFSettings;
      settings.push(s);
    });
    this.changed.emit(settings);
  }

  async getConditions() {
    const conditions = await this._workflow.getFormProperties(FormType.RSF).toPromise();
    if (conditions) this.conditions = conditions;
  }

  addNew() {
    this.getConditions();
    this.roleNotificationSettings?.push({ id: 0, disabled: false, type: RSFSettingType.Notifications });
  }

  edit(r: RSFRoleNotificationSetting) {
    this.getConditions();
    this.tmpRoleNotification = this.utils.cloneDeep(r);
    r.disabled = false;
  }

  cancel(r: RSFRoleNotificationSetting) {
    if (r.id && this.tmpRoleNotification) {
      // restore the temporary setting into the list if it exists
      const idx = this.roleNotificationSettings?.findIndex(x => x.id === this.tmpRoleNotification?.id) ?? -1;
      if (idx > -1 && this.roleNotificationSettings) {
        this.roleNotificationSettings[idx] = this.tmpRoleNotification;
        this.roleNotificationSettings[idx].disabled = true;
      }
      this.tmpRoleNotification = null;
    }
    else if (!r.id) {
      // remove the newly added (unsaved) item from the array
      const i = this.roleNotificationSettings?.findIndex(x => x === r) ?? -1;
      if (i > -1 && this.roleNotificationSettings) {
        this.roleNotificationSettings.splice(i, 1);
      }
    }
  }

  roleQuery = '';                 // text in the input
  r = { role: null as Role | null }; // your selected object

  drop(event: CdkDragDrop<RSFRoleNotificationSetting[]>) {
    if (this.roleNotificationSettings) {
      moveItemInArray(this.roleNotificationSettings, event.previousIndex, event.currentIndex);
      this.reorderAndSaveArray();
    }
  }

  reorderAndSaveArray() {
    var number = 0;
    this.roleNotificationSettings?.forEach(r => {
      r.order = number;
      number++;
    });
    this.save();
  }
}


